(function () {
  var section = document.querySelector(".product-detail");
  if (!section) return;

  var dataEl = section.querySelector(".product-variant-data");
  if (!dataEl) return;

  var variants = [];
  var optionNames = [];
  try {
    variants = JSON.parse(dataEl.getAttribute("data-variants") || "[]");
    optionNames = JSON.parse(dataEl.getAttribute("data-options") || "[]");
  } catch (e) {
    return;
  }

  var colorValueEl = section.querySelector(".color-box .color-value");
  var sizeValueEl = section.querySelector(".size-box .size-value");
  var sizeBoxEl = section.querySelector(".size-variants-box");
  var priceBoxEl = section.querySelector(".price-box");
  var priceValueEl = priceBoxEl ? priceBoxEl.querySelector(".price") : null;
  var compareAtEl = priceBoxEl ? priceBoxEl.querySelector(".compare-at") : null;
  var tagsWrapEl = section.querySelector("[data-product-tags-wrap]");
  var discountTagEl = section.querySelector("[data-product-discount-tag]");
  var moneyFormat = getMoneyFormat(
    section.querySelector(".product-money-format"),
  );
  var btnRow = section.querySelector(".btn-row");
  var qtyBoxEl = section.querySelector(".qty-box");
  var variantIdInput = section.querySelector(".variant-id-input");
  var returnToInput = section.querySelector(".return-to-input");
  var addToCartButton = section.querySelector(".add-to-cart");
  var buyNowButton = section.querySelector(".buy-now");
  var productForm = section.querySelector(".product-form");
  var qtyInput = section.querySelector(".qty-input");
  var qtyButtons = section.querySelectorAll(".qty-btn");

  var colorIndex = findOptionIndex(optionNames, [
    "color",
    "colour",
    "material & color",
    "material/color",
    "material and color",
    "สี",
    "颜色",
    "材质与颜色",
    "顏色",
    "材質與顏色",
    "色",
    "カラー",
    "素材と色",
    "색상",
    "색",
    "소재 및 색상",
  ]);
  var sizeIndex = findOptionIndex(optionNames, [
    "size",
    "shoe size",
    "ขนาด",
    "尺码",
    "尺寸",
    "サイズ",
    "靴のサイズ",
    "鞋码",
    "尺碼",
    "鞋碼",
    "신발 사이즈",
    "사이즈",
    "크기",
  ]);

  var selectedVariant = findInitialVariant(
    variants,
    dataEl.getAttribute("data-selected-variant-id"),
  );

  initMobileGallery();
  updateHeaderValues(selectedVariant);
  buildSizeButtons(getOption(selectedVariant, colorIndex));
  syncVariantInput(selectedVariant);

  if (sizeBoxEl) {
    sizeBoxEl.addEventListener("click", function (event) {
      var target = event.target;
      if (!target || !target.classList.contains("size-variant")) return;
      if (target.disabled) return;

      var selectedSize = target.getAttribute("data-value");
      var currentColor = getOption(selectedVariant, colorIndex);

      var nextVariant =
        findVariant(currentColor, selectedSize) ||
        findVariant(null, selectedSize);
      if (!nextVariant) return;

      selectedVariant = nextVariant;
      updateHeaderValues(selectedVariant);
      buildSizeButtons(getOption(selectedVariant, colorIndex));
    });
  }

  if (qtyBoxEl) {
    qtyInput = qtyBoxEl.querySelector(".qty-input");
    qtyBoxEl.addEventListener("click", function (event) {
      var target = event.target;
      if (!target || !target.classList.contains("qty-btn")) return;
      if (!qtyInput) return;

      var current = parseInt(qtyInput.value, 10);
      if (isNaN(current) || current < 1) current = 1;

      if (target.getAttribute("data-action") === "increase") {
        qtyInput.value = current + 1;
      } else {
        qtyInput.value = Math.max(1, current - 1);
      }
    });

    if (qtyInput) {
      qtyInput.addEventListener("change", function () {
        var value = parseInt(qtyInput.value, 10);
        if (isNaN(value) || value < 1) {
          qtyInput.value = 1;
        }
      });
    }
  }

  function updateHeaderValues(variant) {
    if (!variant) return;
    if (colorValueEl && colorIndex >= 0) {
      colorValueEl.textContent = getOption(variant, colorIndex) || "";
    }
    if (sizeValueEl && sizeIndex >= 0) {
      sizeValueEl.textContent = getOption(variant, sizeIndex) || "";
    }
    updatePrices(variant);
    syncVariantInput(variant);
    updatePurchaseState(variant);
  }

  function buildSizeButtons(colorValue) {
    if (!sizeBoxEl || sizeIndex < 0) return;

    var sizes = getAllSizes();
    sizeBoxEl.innerHTML = "";

    sizes.forEach(function (sizeValue) {
      var sizeButton = document.createElement("button");
      sizeButton.type = "button";
      sizeButton.className = "size-variant";
      sizeButton.textContent = sizeValue;
      sizeButton.setAttribute("data-value", sizeValue);

      var matchForColor = findVariant(colorValue, sizeValue);
      var matchAny = findVariant(null, sizeValue);

      if (!matchForColor && !matchAny) {
        sizeButton.disabled = true;
        sizeButton.classList.add("is-unavailable");
      } else if (matchForColor && isSoldOut(matchForColor)) {
        sizeButton.disabled = true;
        sizeButton.classList.add("is-unavailable");
        sizeButton.classList.add("sold-out");
      } else if (!matchForColor && matchAny && isSoldOut(matchAny)) {
        sizeButton.disabled = true;
        sizeButton.classList.add("is-unavailable");
        sizeButton.classList.add("sold-out");
      }

      if (getOption(selectedVariant, sizeIndex) === sizeValue) {
        sizeButton.classList.add("is-active");
      }

      sizeBoxEl.appendChild(sizeButton);
    });

    ensureActiveSize();
  }

  function ensureActiveSize() {
    if (!sizeBoxEl) return;
    var activeButton = sizeBoxEl.querySelector(".size-variant.is-active");
    if (activeButton && !activeButton.classList.contains("is-unavailable")) {
      return;
    }

    if (activeButton) {
      activeButton.classList.remove("is-active");
    }

    var candidates = sizeBoxEl.querySelectorAll(".size-variant");
    for (var i = 0; i < candidates.length; i++) {
      var candidate = candidates[i];
      if (
        !candidate.classList.contains("is-unavailable") &&
        !candidate.disabled
      ) {
        candidate.classList.add("is-active");
        var nextSize = candidate.getAttribute("data-value");
        var currentColor = getOption(selectedVariant, colorIndex);
        var nextVariant =
          findVariant(currentColor, nextSize) || findVariant(null, nextSize);
        if (nextVariant) {
          selectedVariant = nextVariant;
          updateHeaderValues(selectedVariant);
        }
        break;
      }
    }
  }

  function updatePrices(variant) {
    if (!variant) return;
    if (priceValueEl) {
      priceValueEl.setAttribute("data-money-cents", variant.price || 0);
      priceValueEl.textContent = formatMoney(variant.price, moneyFormat);
    }
    if (compareAtEl) {
      if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
      ) {
        compareAtEl.setAttribute("data-money-cents", variant.compare_at_price);
        compareAtEl.textContent = formatMoney(
          variant.compare_at_price,
          moneyFormat,
        );
        compareAtEl.style.display = "";
        if (priceValueEl) {
          priceValueEl.classList.add("price-main");
        }
        if (discountTagEl) {
          var discount = Math.round(
            ((variant.compare_at_price - variant.price) * 100) /
              variant.compare_at_price,
          );
          discountTagEl.textContent = discount + "% discount";
          discountTagEl.classList.remove("hidden");
        }
        if (tagsWrapEl) {
          tagsWrapEl.classList.remove("hidden");
        }
      } else {
        compareAtEl.removeAttribute("data-money-cents");
        compareAtEl.textContent = "";
        compareAtEl.style.display = "none";
        if (priceValueEl) {
          priceValueEl.classList.remove("price-main");
        }
        if (discountTagEl) {
          discountTagEl.textContent = "";
          discountTagEl.classList.add("hidden");
        }
        if (tagsWrapEl && tagsWrapEl.children.length === 1) {
          tagsWrapEl.classList.add("hidden");
        }
      }
    } else if (discountTagEl) {
      discountTagEl.textContent = "";
      discountTagEl.classList.add("hidden");
      if (tagsWrapEl && tagsWrapEl.children.length === 1) {
        tagsWrapEl.classList.add("hidden");
      }
    }
  }

  function initMobileGallery() {
    if (!window.Swiper) return;

    var mainGalleryEl = section.querySelector("[data-product-mobile-main]");
    var thumbsGalleryEl = section.querySelector("[data-product-mobile-thumbs]");

    if (!mainGalleryEl || !thumbsGalleryEl) return;
    if (mainGalleryEl.swiper || thumbsGalleryEl.swiper) return;

    var thumbsSwiper = new window.Swiper(thumbsGalleryEl, {
      spaceBetween: 8,
      slidesPerView: 4,
      watchSlidesProgress: true,
      pagination: {
        el: thumbsGalleryEl.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });

    new window.Swiper(mainGalleryEl, {
      slidesPerView: 1,
      spaceBetween: 12,
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  }

  function getAllSizes() {
    var sizeMap = {};
    variants.forEach(function (variant) {
      var value = getOption(variant, sizeIndex);
      if (value !== null && value !== undefined && value !== "") {
        sizeMap[value] = true;
      }
    });

    var sizeList = Object.keys(sizeMap);
    var numeric = sizeList.every(function (value) {
      return /^\d+(\.\d+)?$/.test(value);
    });

    if (numeric) {
      sizeList.sort(function (a, b) {
        return parseFloat(a) - parseFloat(b);
      });
    } else {
      sizeList.sort();
    }

    return sizeList;
  }

  function findVariant(colorValue, sizeValue) {
    return variants.find(function (variant) {
      var matchesColor =
        colorIndex < 0 ||
        colorValue === null ||
        getOption(variant, colorIndex) === colorValue;
      var matchesSize =
        sizeIndex < 0 ||
        sizeValue === null ||
        getOption(variant, sizeIndex) === sizeValue;
      return matchesColor && matchesSize;
    });
  }

  function findInitialVariant(allVariants, selectedId) {
    var id = parseInt(selectedId, 10);
    var exact = allVariants.find(function (variant) {
      return variant.id === id;
    });
    if (exact) return exact;

    var available = allVariants.find(function (variant) {
      return variant.available;
    });
    return available || allVariants[0] || null;
  }

  function getOption(variant, index) {
    if (!variant || index < 0) return null;
    if (variant.options && variant.options.length > index) {
      return variant.options[index];
    }
    var key = "option" + (index + 1);
    return variant[key] || null;
  }

  function findOptionIndex(options, names) {
    if (!Array.isArray(options)) return -1;
    var lowerNames = names.map(function (name) {
      return String(name).toLowerCase();
    });
    for (var i = 0; i < options.length; i++) {
      var option = String(options[i]).toLowerCase();
      if (lowerNames.indexOf(option) !== -1) {
        return i;
      }
    }
    return -1;
  }

  function isSoldOut(variant) {
    if (!variant) return false;
    if (variant.available === false) return true;
    if (variant.inventory_policy === "continue") return false;
    if (variant.inventory_management) {
      if (
        typeof variant.inventory_quantity === "number" &&
        variant.inventory_quantity <= 0
      ) {
        return true;
      }
    }
    return false;
  }

  function hasPurchasableVariant() {
    return variants.some(function (variant) {
      return !isSoldOut(variant);
    });
  }

  function updatePurchaseState(variant) {
    var soldOut = !variant || isSoldOut(variant) || !hasPurchasableVariant();

    if (qtyBoxEl) {
      qtyBoxEl.hidden = soldOut;
    }

    if (btnRow) {
      btnRow.style.gridTemplateColumns = soldOut ? "1fr" : "";
    }

    if (addToCartButton) {
      var addLabel =
        addToCartButton.getAttribute("data-add-to-cart-label") || "Add to cart";
      var soldOutLabel =
        addToCartButton.getAttribute("data-sold-out-label") || "Sold out";
      addToCartButton.textContent = soldOut ? soldOutLabel : addLabel;
      addToCartButton.disabled = soldOut;
      addToCartButton.setAttribute("aria-disabled", soldOut ? "true" : "false");
    }

    if (qtyInput) {
      qtyInput.disabled = soldOut;
    }

    if (qtyButtons && qtyButtons.length) {
      qtyButtons.forEach(function (button) {
        button.disabled = soldOut;
      });
    }

    if (buyNowButton) {
      buyNowButton.hidden = soldOut;
      buyNowButton.disabled = soldOut;
    }
  }

  function formatMoney(cents, format) {
    function stripSecondaryBasePrice(value) {
      return String(value || "").replace(/\s*\(THB[^)]*\)/g, "");
    }

    if (
      window.MarmorisStorefrontCurrency &&
      typeof window.MarmorisStorefrontCurrency.formatMoneySync === "function"
    ) {
      return stripSecondaryBasePrice(
        window.MarmorisStorefrontCurrency.formatMoneySync(cents),
      );
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return stripSecondaryBasePrice(window.Shopify.formatMoney(cents, format));
    }

    var value = typeof cents === "string" ? cents.replace(".", "") : cents;
    var centsNumber = parseInt(value, 10);
    if (isNaN(centsNumber)) return "";

    var placeholderRegex =
      /\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/;
    var formatString = format || "${{amount}}";
    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : "amount";

    var formatted = formatWithDelimiters(centsNumber, placeholder);
    return stripSecondaryBasePrice(
      formatString.replace(placeholderRegex, formatted),
    );
  }

  function formatWithDelimiters(number, placeholder) {
    var precision = 2;
    var thousands = ",";
    var decimal = ".";

    if (placeholder === "amount_no_decimals") {
      precision = 0;
    } else if (placeholder === "amount_with_comma_separator") {
      thousands = ".";
      decimal = ",";
    } else if (placeholder === "amount_no_decimals_with_comma_separator") {
      precision = 0;
      thousands = ".";
      decimal = ",";
    }

    var value = (number / 100).toFixed(precision);
    var parts = value.split(".");
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

    return precision ? dollars + decimal + parts[1] : dollars;
  }

  function getMoneyFormat(scriptEl) {
    if (!scriptEl) return "${{amount}}";
    var raw = scriptEl.textContent || "";
    if (!raw) return "${{amount}}";
    try {
      return JSON.parse(raw);
    } catch (e) {
      return raw;
    }
  }

  function syncVariantInput(variant) {
    if (!variantIdInput || !variant) return;
    variantIdInput.value = variant.id;
  }

  if (productForm && buyNowButton && returnToInput) {
    productForm.addEventListener("submit", function (event) {
      if (!returnToInput) return;
      var isBuyNow = event.submitter === buyNowButton;
      returnToInput.value = isBuyNow ? "/checkout" : "";

      if (!isBuyNow && window.CartDrawer && variantIdInput) {
        event.preventDefault();
        var qty = 1;
        var qtyInput = productForm.querySelector(".qty-input");
        if (qtyInput) {
          qty = parseInt(qtyInput.value, 10);
          if (isNaN(qty) || qty < 1) qty = 1;
        }
        window.CartDrawer.addItem({
          id: parseInt(variantIdInput.value, 10),
          quantity: qty,
        });
      }
    });
  }

  updatePurchaseState(selectedVariant);
})();
